// import React, { useState, useEffect, useCallback } from "react";
// import { MainLayout } from "../layout/MainLayout";
// import {
//   Card,
//   Button,
//   Alert,
//   FormGroup,
//   FormInput,
// } from "../ui/base-components";

// const AssignToProject = () => {
//   const apiRootSecond = process.env.REACT_APP_API_ROOT;
//   const apiRoot = process.env.REACT_APP_API_ROOT_OPERATIONAL;
//   const [users, setUsers] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [selectedUsers, setSelectedUsers] = useState([]);
//   const [selectedProjects, setSelectedProjects] = useState([]);
//   const [searchType, setSearchType] = useState("name");
//   const [message, setMessage] = useState({ type: "", text: "" });

//   const [projectSearchQuery, setProjectSearchQuery] = useState("");
//   const [userSearchQuery, setUserSearchQuery] = useState("");

//   const [selectedProjectsText, setSelectedProjectsText] = useState("");
//   const [selectedUsersText, setSelectedUsersText] = useState("");

//   const [filteredProjects, setFilteredProjects] = useState([]);
//   const [filteredUsers, setFilteredUsers] = useState([]);

//   useEffect(() => {
//     const selectedProjectLabels = projects
//       .filter((project) => selectedProjects.includes(project.value))
//       .map((project) => project.label)
//       .join(", ");
//     setSelectedProjectsText(selectedProjectLabels);
//   }, [selectedProjects, projects]);

//   useEffect(() => {
//     const selectedUserLabels = users
//       .filter((user) => selectedUsers.includes(user.value))
//       .map((user) => user.label)
//       .join(", ");
//     setSelectedUsersText(selectedUserLabels);
//   }, [selectedUsers, users]);

//   // Fetch Users
//   const fetchUsers = useCallback(
//     async (query = "") => {
//       try {
//         const response = await fetch(`${apiRoot}/api/user?search=${query}`, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//         });
//         const data = await response.json();
//         const formattedUsers = data.map((user) => ({
//           value: user.id.toString(),
//           label: user.email,
//         }));
//         setUsers(formattedUsers);
//         setFilteredUsers(formattedUsers);
//       } catch (error) {
//         setMessage({ type: "error", text: "Error fetching users" });
//       }
//     },
//     [apiRoot]
//   );

//   const fetchProjects = useCallback(
//     async (query = "") => {
//       try {
//         const response = await fetch(
//           `${apiRootSecond}/api/projects/?search=${query}`,
//           {
//             headers: {
//               Authorization: `Bearer ${localStorage.getItem("token")}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );
//         const data = await response.json();
//         const formattedProjects = data.map((project) => ({
//           value: project.id.toString(),
//           label: searchType === "id" ? project.id.toString() : project.name,
//         }));
//         setProjects(formattedProjects);
//         setFilteredProjects(formattedProjects);
//       } catch (error) {
//         setMessage({ type: "error", text: "Error fetching projects" });
//       }
//     },
//     [apiRootSecond, searchType]
//   );

//   const handleProjectSelection = (e) => {
//     const selectedValues = Array.from(
//       e.target.selectedOptions,
//       (option) => option.value
//     );
//     setSelectedProjects((prevSelected) => {
//       const newSelection = selectedValues.filter(
//         (value) => !prevSelected.includes(value)
//       );
//       return [...new Set([...prevSelected, ...newSelection])];
//     });
//   };

//   const handleUserSelection = (e) => {
//     const selectedValues = Array.from(
//       e.target.selectedOptions,
//       (option) => option.value
//     );
//     setSelectedUsers((prevSelected) => {
//       const newSelection = selectedValues.filter(
//         (value) => !prevSelected.includes(value)
//       );
//       return [...new Set([...prevSelected, ...newSelection])];
//     });
//   };

//   const handleProjectSearch = (e) => {
//     const query = e.target.value;
//     setProjectSearchQuery(query);

//     const filtered = projects.filter((project) =>
//       project.label.toLowerCase().includes(query.toLowerCase())
//     );
//     setFilteredProjects(filtered);
//   };

//   const handleUserSearch = (e) => {
//     const query = e.target.value;
//     setUserSearchQuery(query);

//     const filtered = users.filter((user) =>
//       user.label.toLowerCase().includes(query.toLowerCase())
//     );
//     setFilteredUsers(filtered);
//   };

//   const handleSearchTypeChange = (type) => {
//     setSearchType(type);
//     fetchProjects();
//   };

//   useEffect(() => {
//     fetchUsers();
//     fetchProjects();
//   }, [fetchUsers, fetchProjects]);

//   const handleAssign = async () => {
//     if (!selectedUsers.length || !selectedProjects.length) {
//       setMessage({
//         type: "error",
//         text: "Please select both users and projects",
//       });
//       return;
//     }

//     try {
//       const response = await fetch(`${apiRootSecond}/api/project_assignment/`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//         body: JSON.stringify(
//           selectedUsers.flatMap((userId) =>
//             selectedProjects.map((projectId) => ({
//               user: parseInt(userId),
//               project: parseInt(projectId),
//             }))
//           )
//         ),
//       });

//       if (!response.ok) throw new Error("Failed to assign projects");

//       setMessage({
//         type: "success",
//         text: "Users successfully assigned to projects",
//       });
//       setSelectedUsers([]);
//       setSelectedProjects([]);
//       setProjectSearchQuery("");
//       setUserSearchQuery("");
//       setSelectedProjectsText("");
//       setSelectedUsersText("");
//     } catch (error) {
//       setMessage({ type: "error", text: "Failed to assign users to projects" });
//     }
//   };

//   return (
//     <MainLayout>
//       <div className="p-6 mt-4">
//         <div className="max-w-lg mx-auto">
//           <Card>
//             <div className="space-y-6">
//               <div>
//                 <h2 className="text-2xl font-bold text-gray-900">
//                   Assign Users to Projects
//                 </h2>
//                 <p className="mt-1 text-sm text-gray-600">
//                   Select users and projects to create assignments.
//                 </p>
//               </div>

//               {message.text && (
//                 <Alert type={message.type} message={message.text} />
//               )}

//               <FormGroup>
//                 {/* Search Type Selection */}
//                 <div className="space-y-2">
//                   <label className="block text-sm font-medium text-gray-700">
//                     Search Projects By
//                   </label>
//                   <div className="flex space-x-4">
//                     {["id", "name"].map((type) => (
//                       <label key={type} className="inline-flex items-center">
//                         <input
//                           type="radio"
//                           className="form-radio h-4 w-4 text-blue-600"
//                           checked={searchType === type}
//                           onChange={() => handleSearchTypeChange(type)}
//                         />
//                         <span className="ml-2 text-gray-700 capitalize">
//                           {type === "id" ? "Project ID" : "Project Name"}
//                         </span>
//                       </label>
//                     ))}
//                   </div>
//                 </div>

//                 <div className="space-y-2">
//                   <div className="space-y-2">
//                     <FormInput
//                       label="Search Projects"
//                       type="text"
//                       placeholder="Type to search projects"
//                       value={projectSearchQuery}
//                       onChange={handleProjectSearch}
//                     />
//                     {selectedProjectsText && (
//                       <div className="text-sm text-gray-600 border rounded p-2 bg-gray-50">
//                         Selected: {selectedProjectsText}
//                       </div>
//                     )}
//                   </div>
//                   <select
//                     multiple
//                     value={selectedProjects}
//                     onChange={handleProjectSelection}
//                     className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm 
//                       focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
//                       min-h-[120px] bg-white"
//                   >
//                     {filteredProjects.map((project) => (
//                       <option
//                         key={project.value}
//                         value={project.value}
//                         className={`py-1 px-2 ${
//                           selectedProjects.includes(project.value)
//                             ? "bg-blue-100"
//                             : ""
//                         }`}
//                       >
//                         {project.label}
//                       </option>
//                     ))}
//                   </select>
//                   <p className="text-sm text-gray-500">
//                     Hold Ctrl (Cmd on Mac) to select multiple projects
//                   </p>
//                 </div>

//                 <div className="space-y-2">
//                   <div className="space-y-2">
//                     <FormInput
//                       label="Search Users"
//                       type="text"
//                       placeholder="Type to search users"
//                       value={userSearchQuery}
//                       onChange={handleUserSearch}
//                     />
//                     {selectedUsersText && (
//                       <div className="text-sm text-gray-600 border rounded p-2 bg-gray-50">
//                         Selected: {selectedUsersText}
//                       </div>
//                     )}
//                   </div>
//                   <select
//                     multiple
//                     value={selectedUsers}
//                     onChange={handleUserSelection}
//                     className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm 
//                       focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
//                       min-h-[120px] bg-white"
//                   >
//                     {filteredUsers.map((user) => (
//                       <option
//                         key={user.value}
//                         value={user.value}
//                         className={`py-1 px-2 ${
//                           selectedUsers.includes(user.value)
//                             ? "bg-blue-100"
//                             : ""
//                         }`}
//                       >
//                         {user.label}
//                       </option>
//                     ))}
//                   </select>
//                   <p className="text-sm text-gray-500">
//                     Hold Ctrl (Cmd on Mac) to select multiple users
//                   </p>
//                 </div>
//               </FormGroup>

//               <Button onClick={handleAssign} className="w-full">
//                 Assign Users to Projects
//               </Button>
//             </div>
//           </Card>
//         </div>
//       </div>
//     </MainLayout>
//   );
// };

// export default AssignToProject;
import React, { useState, useEffect, useCallback } from "react";
import { MainLayout } from "../layout/MainLayout";
import { 
  Settings, 
  Users, 
  Search, 
  CheckCircle2, 
  AlertCircle, 
  FolderOpen, 
  User,
  Link,
  X,
  Loader
} from "lucide-react";

const AssignToProject = () => {
  const apiRootSecond = process.env.REACT_APP_API_ROOT;
  const apiRoot = process.env.REACT_APP_API_ROOT_OPERATIONAL;
  const [users, setUsers] = useState([]);
  const [projects, setProjects] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [searchType, setSearchType] = useState("name");
  const [message, setMessage] = useState({ type: "", text: "" });
  const [isLoading, setIsLoading] = useState(false);

  const [projectSearchQuery, setProjectSearchQuery] = useState("");
  const [userSearchQuery, setUserSearchQuery] = useState("");

  const [selectedProjectsText, setSelectedProjectsText] = useState("");
  const [selectedUsersText, setSelectedUsersText] = useState("");

  const [filteredProjects, setFilteredProjects] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);

  useEffect(() => {
    const selectedProjectLabels = projects
      .filter((project) => selectedProjects.includes(project.value))
      .map((project) => project.label)
      .join(", ");
    setSelectedProjectsText(selectedProjectLabels);
  }, [selectedProjects, projects]);

  useEffect(() => {
    const selectedUserLabels = users
      .filter((user) => selectedUsers.includes(user.value))
      .map((user) => user.label)
      .join(", ");
    setSelectedUsersText(selectedUserLabels);
  }, [selectedUsers, users]);

  // Fetch Users
  const fetchUsers = useCallback(
    async (query = "") => {
      try {
        const response = await fetch(`${apiRoot}/api/user?search=${query}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        });
        const data = await response.json();
        const formattedUsers = data.map((user) => ({
          value: user.id.toString(),
          label: user.email,
        }));
        setUsers(formattedUsers);
        setFilteredUsers(formattedUsers);
      } catch (error) {
        setMessage({ type: "error", text: "Error fetching users" });
      }
    },
    [apiRoot]
  );

  const fetchProjects = useCallback(
    async (query = "") => {
      try {
        const response = await fetch(
          `${apiRootSecond}/api/projects/?search=${query}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        const formattedProjects = data.map((project) => ({
          value: project.id.toString(),
          label: searchType === "id" ? project.id.toString() : project.name,
        }));
        setProjects(formattedProjects);
        setFilteredProjects(formattedProjects);
      } catch (error) {
        setMessage({ type: "error", text: "Error fetching projects" });
      }
    },
    [apiRootSecond, searchType]
  );

  const handleProjectSelection = (e) => {
    const selectedValues = Array.from(
      e.target.selectedOptions,
      (option) => option.value
    );
    setSelectedProjects((prevSelected) => {
      const newSelection = selectedValues.filter(
        (value) => !prevSelected.includes(value)
      );
      return [...new Set([...prevSelected, ...newSelection])];
    });
  };

  const handleUserSelection = (e) => {
    const selectedValues = Array.from(
      e.target.selectedOptions,
      (option) => option.value
    );
    setSelectedUsers((prevSelected) => {
      const newSelection = selectedValues.filter(
        (value) => !prevSelected.includes(value)
      );
      return [...new Set([...prevSelected, ...newSelection])];
    });
  };

  const handleProjectSearch = (e) => {
    const query = e.target.value;
    setProjectSearchQuery(query);

    const filtered = projects.filter((project) =>
      project.label.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredProjects(filtered);
  };

  const handleUserSearch = (e) => {
    const query = e.target.value;
    setUserSearchQuery(query);

    const filtered = users.filter((user) =>
      user.label.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredUsers(filtered);
  };

  const handleSearchTypeChange = (type) => {
    setSearchType(type);
    fetchProjects();
  };

  const removeSelectedProject = (projectValue) => {
    setSelectedProjects(prev => prev.filter(p => p !== projectValue));
  };

  const removeSelectedUser = (userValue) => {
    setSelectedUsers(prev => prev.filter(u => u !== userValue));
  };

  useEffect(() => {
    fetchUsers();
    fetchProjects();
  }, [fetchUsers, fetchProjects]);

  const handleAssign = async () => {
    if (!selectedUsers.length || !selectedProjects.length) {
      setMessage({
        type: "error",
        text: "Please select both users and projects",
      });
      return;
    }

    setIsLoading(true);
    try {
      const response = await fetch(`${apiRootSecond}/api/project_assignment/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(
          selectedUsers.flatMap((userId) =>
            selectedProjects.map((projectId) => ({
              user: parseInt(userId),
              project: parseInt(projectId),
            }))
          )
        ),
      });

      if (!response.ok) throw new Error("Failed to assign projects");

      setMessage({
        type: "success",
        text: "Users successfully assigned to projects",
      });
      setSelectedUsers([]);
      setSelectedProjects([]);
      setProjectSearchQuery("");
      setUserSearchQuery("");
      setSelectedProjectsText("");
      setSelectedUsersText("");
    } catch (error) {
      setMessage({ type: "error", text: "Failed to assign users to projects" });
    } finally {
      setIsLoading(false);
    }
  };

  const SelectedItemBadge = ({ item, onRemove, icon: Icon, type }) => (
    <div className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-sm border ${
      type === 'project' 
        ? 'bg-blue-50 border-blue-200 text-blue-700' 
        : 'bg-green-50 border-green-200 text-green-700'
    }`}>
      <Icon className="w-3 h-3" />
      <span className="truncate max-w-[150px]">{item.label}</span>
      <button
        onClick={() => onRemove(item.value)}
        className="hover:bg-white rounded-full p-0.5 transition-colors"
      >
        <X className="w-3 h-3" />
      </button>
    </div>
  );

  return (
    <MainLayout>
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Page Header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-green-600 to-emerald-600 rounded-2xl mb-6 shadow-lg">
              <Link className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-4xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent mb-4">
              Assign Users to Projects
            </h1>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Select users and projects to create assignments and manage access permissions
            </p>
          </div>

          {/* Main Content Card */}
          <div className="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden">
            {/* Card Header */}
            <div className="bg-gradient-to-br from-green-600 to-emerald-600 p-6 relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent"></div>
              <div className="relative z-10">
                <div className="flex items-center gap-3">
                  <div className="inline-flex items-center justify-center w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl">
                    <Settings className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h2 className="text-xl font-bold text-white">Project Assignment</h2>
                    <p className="text-white/80 text-sm">Connect users with their designated projects</p>
                  </div>
                </div>
              </div>
              
              {/* Decorative Elements */}
              <div className="absolute -top-8 -right-8 w-24 h-24 bg-white/10 rounded-full"></div>
              <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-white/10 rounded-full"></div>
            </div>

            {/* Card Content */}
            <div className="p-8">
              {/* Alert Messages */}
              {message.text && (
                <div className={`mb-6 p-4 rounded-xl border flex items-center gap-3 ${
                  message.type === "success" 
                    ? "bg-green-50 border-green-200 text-green-700" 
                    : "bg-red-50 border-red-200 text-red-700"
                }`}>
                  {message.type === "success" ? (
                    <CheckCircle2 className="w-5 h-5 flex-shrink-0" />
                  ) : (
                    <AlertCircle className="w-5 h-5 flex-shrink-0" />
                  )}
                  <p className="text-sm font-medium">{message.text}</p>
                </div>
              )}

              <div className="space-y-8">
                {/* Search Type Selection */}
                <div className="bg-slate-50 rounded-xl p-4 border border-slate-200">
                  <h3 className="text-sm font-semibold text-slate-700 mb-3 flex items-center gap-2">
                    <Search className="w-4 h-4" />
                    Search Projects By
                  </h3>
                  <div className="flex gap-6">
                    {["id", "name"].map((type) => (
                      <label key={type} className="inline-flex items-center cursor-pointer">
                        <input
                          type="radio"
                          className="form-radio h-4 w-4 text-green-600 border-slate-300 focus:ring-green-500"
                          checked={searchType === type}
                          onChange={() => handleSearchTypeChange(type)}
                        />
                        <span className="ml-2 text-slate-700 font-medium">
                          {type === "id" ? "Project ID" : "Project Name"}
                        </span>
                      </label>
                    ))}
                  </div>
                </div>

                {/* Projects Section */}
                <div className="space-y-4">
                  <h3 className="text-lg font-bold text-slate-800 flex items-center gap-2">
                    <FolderOpen className="w-5 h-5 text-blue-600" />
                    Select Projects
                  </h3>
                  
                  {/* Project Search */}
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <Search className="h-5 w-5 text-slate-400" />
                    </div>
                    <input
                      type="text"
                      placeholder="Search projects..."
                      value={projectSearchQuery}
                      onChange={handleProjectSearch}
                      className="w-full pl-10 pr-4 py-3 border border-slate-300 rounded-xl focus:ring-2 
                        focus:ring-green-500 focus:border-green-500 transition-all duration-200 bg-slate-50 focus:bg-white"
                    />
                  </div>

                  {/* Selected Projects Display */}
                  {selectedProjects.length > 0 && (
                    <div className="p-4 bg-blue-50 rounded-xl border border-blue-200">
                      <h4 className="text-sm font-semibold text-blue-700 mb-2">Selected Projects:</h4>
                      <div className="flex flex-wrap gap-2">
                        {projects
                          .filter(project => selectedProjects.includes(project.value))
                          .map(project => (
                            <SelectedItemBadge
                              key={project.value}
                              item={project}
                              onRemove={removeSelectedProject}
                              icon={FolderOpen}
                              type="project"
                            />
                          ))
                        }
                      </div>
                    </div>
                  )}

                  {/* Project Selection */}
                  <select
                    multiple
                    value={selectedProjects}
                    onChange={handleProjectSelection}
                    className="w-full px-4 py-3 border border-slate-300 rounded-xl focus:ring-2 
                      focus:ring-green-500 focus:border-green-500 min-h-[160px] bg-white transition-all duration-200"
                  >
                    {filteredProjects.map((project) => (
                      <option
                        key={project.value}
                        value={project.value}
                        className={`py-2 px-2 ${
                          selectedProjects.includes(project.value)
                            ? "bg-blue-100 text-blue-800"
                            : "hover:bg-slate-50"
                        }`}
                      >
                        {project.label}
                      </option>
                    ))}
                  </select>
                  <p className="text-sm text-slate-500 flex items-center gap-1">
                    <AlertCircle className="w-3 h-3" />
                    Hold Ctrl (Cmd on Mac) to select multiple projects
                  </p>
                </div>

                {/* Users Section */}
                <div className="space-y-4">
                  <h3 className="text-lg font-bold text-slate-800 flex items-center gap-2">
                    <Users className="w-5 h-5 text-green-600" />
                    Select Users
                  </h3>
                  
                  {/* User Search */}
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <Search className="h-5 w-5 text-slate-400" />
                    </div>
                    <input
                      type="text"
                      placeholder="Search users..."
                      value={userSearchQuery}
                      onChange={handleUserSearch}
                      className="w-full pl-10 pr-4 py-3 border border-slate-300 rounded-xl focus:ring-2 
                        focus:ring-green-500 focus:border-green-500 transition-all duration-200 bg-slate-50 focus:bg-white"
                    />
                  </div>

                  {/* Selected Users Display */}
                  {selectedUsers.length > 0 && (
                    <div className="p-4 bg-green-50 rounded-xl border border-green-200">
                      <h4 className="text-sm font-semibold text-green-700 mb-2">Selected Users:</h4>
                      <div className="flex flex-wrap gap-2">
                        {users
                          .filter(user => selectedUsers.includes(user.value))
                          .map(user => (
                            <SelectedItemBadge
                              key={user.value}
                              item={user}
                              onRemove={removeSelectedUser}
                              icon={User}
                              type="user"
                            />
                          ))
                        }
                      </div>
                    </div>
                  )}

                  {/* User Selection */}
                  <select
                    multiple
                    value={selectedUsers}
                    onChange={handleUserSelection}
                    className="w-full px-4 py-3 border border-slate-300 rounded-xl focus:ring-2 
                      focus:ring-green-500 focus:border-green-500 min-h-[160px] bg-white transition-all duration-200"
                  >
                    {filteredUsers.map((user) => (
                      <option
                        key={user.value}
                        value={user.value}
                        className={`py-2 px-2 ${
                          selectedUsers.includes(user.value)
                            ? "bg-green-100 text-green-800"
                            : "hover:bg-slate-50"
                        }`}
                      >
                        {user.label}
                      </option>
                    ))}
                  </select>
                  <p className="text-sm text-slate-500 flex items-center gap-1">
                    <AlertCircle className="w-3 h-3" />
                    Hold Ctrl (Cmd on Mac) to select multiple users
                  </p>
                </div>

                {/* Assignment Summary */}
                {(selectedUsers.length > 0 || selectedProjects.length > 0) && (
                  <div className="bg-slate-50 rounded-xl p-6 border border-slate-200">
                    <h3 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
                      <Link className="w-5 h-5 text-purple-600" />
                      Assignment Summary
                    </h3>
                    <div className="grid md:grid-cols-2 gap-4 text-sm">
                      <div>
                        <span className="font-semibold text-slate-700">Users Selected:</span>
                        <span className="ml-2 text-green-600">{selectedUsers.length}</span>
                      </div>
                      <div>
                        <span className="font-semibold text-slate-700">Projects Selected:</span>
                        <span className="ml-2 text-blue-600">{selectedProjects.length}</span>
                      </div>
                      <div className="md:col-span-2">
                        <span className="font-semibold text-slate-700">Total Assignments:</span>
                        <span className="ml-2 text-purple-600 font-bold">
                          {selectedUsers.length * selectedProjects.length}
                        </span>
                      </div>
                    </div>
                  </div>
                )}

                {/* Submit Button */}
                <button
                  onClick={handleAssign}
                  disabled={isLoading || !selectedUsers.length || !selectedProjects.length}
                  className="group w-full py-4 px-6 bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 
                    text-white rounded-xl font-semibold transition-all duration-200 flex items-center justify-center gap-3
                    disabled:opacity-50 disabled:cursor-not-allowed shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                >
                  {isLoading ? (
                    <>
                      <Loader className="w-5 h-5 animate-spin" />
                      Assigning Users...
                    </>
                  ) : (
                    <>
                      <Link className="w-5 h-5 group-hover:scale-110 transition-transform duration-200" />
                      Assign Users to Projects
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default AssignToProject;